import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DefaultLayoutComponent } from './shared/default-layout.component';
import { IsLoggedInGuard } from '@soleran/authentication';
import { AuthenticationModule } from '@soleran/authentication';
import { NavSuiteResolver } from './shared/nav-suite.resolver';
const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login-page/login-page.module').then(
        (m) => m.LoginPageModule
      ),
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [IsLoggedInGuard],
    resolve: [NavSuiteResolver],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      {
        path: 'home',
        loadChildren: () =>
          import('./pages/home-page/home-page.module').then(
            (m) => m.HomePageModule
          ),
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./pages/dashboard-page/dashboard-page.module').then(
            (m) => m.DashboardPageModule
          ),
      },
      {
        path: 'view',
        loadChildren: () =>
          import('./pages/view-page/view-page.module').then(
            (m) => m.ViewPageModule
          ),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./pages/profile-page/profile-page.module').then(
            (m) => m.ProfilePageModule
          ),
      },
      {
        path: 'security',
        loadChildren: () =>
          import('./pages/security-page/security-page.module').then(
            (m) => m.SecurityPageModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes), AuthenticationModule],
  exports: [RouterModule],
})
export class AppRoutingModule {}
